import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, shareReplay } from 'rxjs';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import { environment } from 'src/environments/environment';

dayjs.extend(relativeTime);

export interface ServiceInfo {
    service: string;
    version: string;
    last_updated: string;
}

interface HealthDetailResponse {
    server_version: string | null;
    server_last_commit_time: string | null;
    web_version: string | null;
    web_last_commit_time: string | null;
}

@Injectable({
    providedIn: 'root'
})
export class HealthService {

    private readonly healthDetailURL = `${environment.serverUrl}/api/health`;
    private healthDetail$?: Observable<ServiceInfo[]>;

    constructor(private http: HttpClient) { }

    getHealthDetail(): Observable<ServiceInfo[]> {
        if (!this.healthDetail$) {
            return this.http.get<HealthDetailResponse>(this.healthDetailURL).pipe(
                map((res) => [
                    {
                        service: 'mango-server',
                        version: res.server_version ?? 'Unknown',
                        last_updated: res.server_last_commit_time ? dayjs(res.server_last_commit_time).fromNow() : 'Unknown'
                    },
                    {
                        service: 'mango-web',
                        version: environment.webCommit ?? 'Unknown',
                        last_updated: environment.webCommitTime ? dayjs(environment.webCommitTime).fromNow() : 'Unknown'
                    }
                ]),
                shareReplay(1)
            );
        }

        return this.healthDetail$;
    }
}
